import React from 'react';
import classnames from 'classnames';

import { Avatar } from 'uikit/avatars';
import { Typo } from 'uikit/content';

import styles from '../styles/userDetailsRow.module.scss';

export default ({
  position, code, avatarUrl, name, className,
}) => {
  const positionAndCode = (position && code)
    ? (
      <>
        <span>{position}</span>
        <span className={styles.code}>{code}</span>
      </>
    ) : position || code;

  return (
    <div className={classnames(styles.element, className)}>
      <Avatar avatar={avatarUrl} name={name} size="medium" />
      <div>
        <Typo variant="s02" weight="medium">{name}</Typo>
        <Typo variant="s01" className={styles.metaText}>{positionAndCode}</Typo>
      </div>
    </div>
  );
};
